import PaymentHeader from "../../components/PaymentHeader"
import WithSidebar from "../../layouts/WithSidebar"
import PaymentList from "../../components/Payment-list"
import { useEffect, useState } from "react"
import { ajax } from "../../scripts/helper"
import utils from "../../scripts/utils"
import { useSnackbar } from 'notistack'
import "./payments.css";
import "../../fonts/font.css"
import context from '../../scripts/context'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import List from "../../components/List"

dayjs.extend(utc)

const Payments = () => {
    
    const paymentInputFilter = context.getPaymentInputFilter()
    const { enqueueSnackbar } = useSnackbar()

    const [paymentLinks, setPaymentLinks] = useState([])
    const [totalCounts, setTotalCounts] = useState(paymentInputFilter.totalCounts);
    const [page, setPage] = useState(paymentInputFilter.page)
    const [rowsPerPage, setRowsPerPage] = useState(paymentInputFilter.rowsPerPage)
    const makeParams = (inputs)=>{
        let params = ''
        let count = 0
        Object.keys(inputs).forEach( (e) => {
            if(inputs[e].type !== 'select' && inputs[e].value ) {
                if(inputs[e].isDate) {
                    params+= `&${inputs[e].name}=${inputs[e].value.utc(true).toISOString()}`
                    count ++
                }else{
                    params += `&${inputs[e].name}=${inputs[e].value}`
                    count ++
                }
            }
            if(inputs[e].type === 'select' && inputs[e].value) {
                params += `&${inputs[e].name}=${inputs[e].selected}`
                count ++
            }

        })
        // setFilterNumber(count)
        return {params, count}
    }

    const firstParams = makeParams(paymentInputFilter)
    const [params, setParams] = useState(firstParams.params)
    const [filterNumber, setFilterNumber] = useState(firstParams.count)
    const columns = [
        {name: 'ID', field: 'id'},
        {name: 'Type', field: 'paymentType'},
        {name: 'Product', field: 'product'},
        {name: 'Reference', field: ''},
        {name: 'Contact', field: ''},
        {name: 'Date', field: 'creationDate'},
        {name: 'Amount', field: 'amount'},
        {name: 'Status', field: 'status'},
        {name: 'Actions', field: ''},
    ]


    const getPaymentLinks = async (page) => {
        const filter = context.getPaymentInputFilter()
        const res = await ajax({
            method: 'GET',
            url: `${utils.urls.paymentList}?size=${filter.rowsPerPage}&page=${page}${params}${(filter.sortField ? `&sortField=${filter.sortField}&direction=${filter.direction || 'DESC'}`: '')}` ,
            snackbar: enqueueSnackbar,
            hasToken: true
        })
        if(!res) return 
        setPaymentLinks(res.data.content)
        context.setPaymentInputFilter({
            ...context.getPaymentInputFilter(),
            totalCounts:res.data.totalElements
        })
        setTotalCounts(res.data.totalElements)
    }
    const exportCsv = async()=>{
        const res = await ajax({
            method: 'GET',
            url: `${utils.urls.transactionExport}?page=${page}${params}`,
            snackbar: enqueueSnackbar,
            hasToken: true,
            responseType:'blob'
        })
        if(!res) return 
        // const blob = res.blob()
        const blob = new Blob([res.data], {type:'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        document.body.append(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }
    
    const inquiry = async (id)=>{
        const res = await ajax({
            method: 'GET',
            hasToken: true,
            url: utils.urls.inquiryUpdate(id),
            snackbar: enqueueSnackbar
        })
        if(!res) return
        setPaymentLinks(paymentLinks.map(p=>{
            if(p.id===res.data.id) return {...p, status:res.data.status}
            return p
        }))
    }
    
    const blockPayment = async(id)=>{
        const res = await ajax({
            method:"GET",
            url: utils.urls.transactionBlock(id),
            hasToken: true,
            snackbar: enqueueSnackbar
        })
        if(!res) return
        setPaymentLinks(paymentLinks.map(p=>{
            if(p.id===res.data.id) return res.data
            return p
        }))
    }
    const unblockPayment = async(id)=>{
        const res = await ajax({
            method:"GET",
            url: utils.urls.transactionUnblock(id),
            hasToken: true,
            snackbar: enqueueSnackbar
        })
        if(!res) return
        setPaymentLinks(paymentLinks.map(p=>{
            if(p.id===res.data.id) return res.data
            return p
        }))
    }

    const onPageChange = (page, rowsPerPage=10) => {
        context.setPaymentInputFilter({
            ...context.getPaymentInputFilter(),
            page:page,
            rowsPerPage:rowsPerPage
        })
        setPage(page)
        setRowsPerPage(rowsPerPage)
        getPaymentLinks(page)
    }

    const onSortChange = (name, direction) => {
        context.setPaymentInputFilter({
            ...context.getPaymentInputFilter(),
            sortField: name,
            direction: direction
        })
        getPaymentLinks(page)
    }

    const actions = {
        onBlockPayment: async(row)=>{
            if(row.status==='BLOCKED'){
                await unblockPayment(row.id)
            } else {
                await blockPayment(row.id)
            }
        },
        onSortChange,
        inquiry
    }

    const onFilter = (inputs) => {
        const params = makeParams(inputs).params
        setFilterNumber(makeParams(inputs).count)
        context.setPaymentInputFilter({
            ...inputs,
            page:0
        })
        setPage(0)
        setParams(params)
    }
    
    const onRefresh = () => {
        context.setPaymentInputFilter({
            ...context.getPaymentInputFilter(),
            sortField: '',
            direction: ''
        })
        setPaymentLinks([])
        getPaymentLinks(page)
    }
    


    // useEffect( () => {
    //     getPaymentLinks(page)
    // }, [])

    useEffect( () => {
        getPaymentLinks(page)
    }, [params])

    return (
        <WithSidebar pageTitle={"Payment listing"} breadcrumb={"Dashboard > Payment listing"} listHeaders={<PaymentHeader count={filterNumber} onExport={exportCsv} onFilter={(inputs) => onFilter(inputs)} onRefresh={onRefresh}/>}>
            <List columns={columns} rows={paymentLinks} type={'payments'} totalCounts={totalCounts} page={page} rowsPerPage={rowsPerPage} onPageChange={(page, rowsPerPage) => onPageChange(page, rowsPerPage)} actions={actions} sortObj= {{sortField : context.getPaymentInputFilter().sortField,direction:  context.getPaymentInputFilter().direction}}/>
        </WithSidebar>
    )
}
export default Payments